// extracted by mini-css-extract-plugin
export default {"main":"Dea-z"};